module.exports = __webpack_public_path__ + "img/stock6.02c85474.png";